import { useAppSelector } from "../../../../redux/hooks/redux";
import { PaginationLoadingOverlay } from "../../../clients/PaginationLoadingOverlay";
import { PortingFormStepper } from "../components/PortingForm";
import { Ticket } from "../components/Ticket";
import { usePortingQuery } from "../hooks/usePortingQuery";

export const PortingOrchestrator = () => {
  const { company } = useAppSelector((state) => state.userState);


  const portingQuery = usePortingQuery({ companyId: company.id });

  if (portingQuery.isLoading) return <PaginationLoadingOverlay isVisible={portingQuery.isLoading} />;
  if (portingQuery.data) return <Ticket ticket={portingQuery.data} />;
  return <PortingFormStepper />;
};
